export default __webpack_public_path__ + "static/media/box-bg.4513a0d7.png";